module.exports = __webpack_public_path__ + "8f3ddeb6d7563b273fc80b1b787060f6.svg";